export default __webpack_public_path__ + "static/media/Revofil.7b84e3b4.png";